import React from 'react';

/**
 * Disabled: onboarding now runs as a Copilot chat conversation (websites, documents, use cases),
 * so the "Steps to first publish" side panel is no longer shown for unpublished apps. The panel
 * and its unpublished-app check are kept; set this to true to show it again.
 */
export const SHOW_PUBLISH_STEPPER = false;

export default function PublishStepper() {
    const steps = [
        { title: 'Build your agent', description: 'Describe your idea and refine it with Copilot.' },
        { title: 'Add knowledge', description: 'Add documents, FAQs, or website content your agent can use.', optional: true },
        { title: 'Test conversations', description: 'Try your agent in the simulator.' },
        { title: 'Publish first version', description: 'Make your agent ready for your channels.' },
    ];

    return (
        <aside aria-label="Steps to first publish" className="shrink-0 border-b border-gray-200 bg-gray-50/80 lg:flex lg:w-56 lg:flex-col lg:overflow-y-auto lg:border-b-0 lg:border-r xl:w-64">
            <div className="px-4 pb-3 pt-5 lg:px-5 lg:pt-7">
                <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                    <span className="h-1.5 w-1.5 rounded-full bg-brand-lime" aria-hidden="true" /> Unpublished
                </span>
                <h2 className="mt-3 text-sm font-semibold text-gray-900">Bring your agent to life</h2>
                <p className="mt-1 hidden text-xs leading-5 text-gray-500 lg:block">From your first idea to your first live version.</p>
            </div>
            <div className="px-3 pb-4 lg:py-3">
                <ol aria-label="Publishing guide" className="grid grid-cols-2 gap-1 sm:grid-cols-4 lg:block lg:space-y-2">
                    {steps.map((step, index) => (
                        <li key={step.title} aria-current={index === 0 ? 'step' : undefined} className="relative">
                            {index < steps.length - 1 && <span aria-hidden="true" className="absolute left-[26px] top-12 hidden h-9 w-px bg-gray-200 lg:block" />}
                            <div className={`relative flex h-full flex-col gap-2 rounded-xl p-3 lg:flex-row lg:gap-3 ${index === 0 ? 'bg-white shadow-sm ring-1 ring-gray-200' : ''}`}>
                                <span aria-hidden="true" className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${index === 0 ? 'bg-gray-900 text-brand-lime dark:bg-brand-lime' : 'border border-gray-200 bg-gray-50 text-gray-400'}`}>{index + 1}</span>
                                <span className="min-w-0 lg:pt-1">
                                    <span className={`block text-xs font-semibold ${index === 0 ? 'text-gray-900' : 'text-gray-600'}`}>{step.title}</span>
                                    {step.optional && <span className="mt-1 inline-block rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-500">Optional</span>}
                                    <span className="mt-1.5 hidden text-xs leading-5 text-gray-500 lg:block">{step.description}</span>
                                    {index === 0 && <span className="mt-2 hidden text-[10px] font-medium text-gray-500 dark:text-brand-lime lg:block">You are here</span>}
                                </span>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </aside>
    );
}
